// extracted by mini-css-extract-plugin
module.exports = {"grayframe":"styles_grayframe__3IMGP"};